import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

var AppBreadcrumbs = /*#__PURE__*/function (_Vue) {
  _inherits(AppBreadcrumbs, _Vue);

  var _super = _createSuper(AppBreadcrumbs);

  function AppBreadcrumbs() {
    _classCallCheck(this, AppBreadcrumbs);

    return _super.apply(this, arguments);
  }

  _createClass(AppBreadcrumbs, [{
    key: "routeBack",
    value: function routeBack() {
      this.$router.go(-1);
    }
  }]);

  return AppBreadcrumbs;
}(Vue);

__decorate([Prop({
  type: Array,
  default: []
})], AppBreadcrumbs.prototype, "breadcrumbs", void 0);

__decorate([Prop(Boolean)], AppBreadcrumbs.prototype, "showBack", void 0);

AppBreadcrumbs = __decorate([Component], AppBreadcrumbs);
export default AppBreadcrumbs;